import { Card, IconWithTextLockup, NavList } from '@deckee/deck-hand';
import React, { FC, MouseEvent } from 'react';
import { useTheme } from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { openWithInAppBrowser } from '../../../../services/in-app-browser';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import { infoCircleFlush, ReactSvg } from '../../../shared/vector-images';

type MapInfoLinkProps = {
  url: string;
  eventName: string;
  description: string;
  divider?: boolean;
};

const MapInfoLink: FC<MapInfoLinkProps> = ({
  url,
  eventName,
  description,
  divider,
}) => {
  const theme = useTheme();

  const handleClick = async (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    await captureEvent({
      type: eventName,
      payload: {},
      sendToAmplitude: true,
    });

    try {
      await openWithInAppBrowser({ url });
    } catch (err) {
      // fallback: open in new tab if in-app browser fails
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <NavList.Item
      chevron
      divider={divider}
      href={url}
      hrefTarget="_blank"
      onClick={handleClick}
    >
      <IconWithTextLockup
        image={
          <ReactSvg
            toDisplay={infoCircleFlush()}
            options={{
              fillColor: theme.colors.primary,
            }}
            width={24}
            height={24}
          />
        }
        description={description}
        descriptionColor={theme.colors.black}
      />
    </NavList.Item>
  );
};

const MapInformationPage: FC = () => (
  <SheetLayout heading="Map data sources" showMenuBar={false} showMapOverlay>
    <SheetBody>
      <Card>
        <Card.Body>
          <NavList edge grouped>
            <MapInfoLink
              url="https://www.mapbox.com/about/maps/"
              eventName="map-information: select mapbox"
              description="© Mapbox"
              divider
            />
            <MapInfoLink
              url="https://www.openstreetmap.org/copyright"
              eventName="map-information: select open street map"
              description="© Open Street Map"
            />
            <MapInfoLink
              url="https://www.maxar.com/"
              eventName="map-information: select maxar"
              description="© Maxar"
            />
            <MapInfoLink
              url="https://deckee.com/third-party-notices"
              eventName="map-information: select third party notices"
              description="Third party notices"
            />
            <MapInfoLink
              url="https://apps.mapbox.com/feedback/?owner=mikeboata&id=nautical-2025-07-03&access_token=pk.eyJ1IjoibWlrZWJvYXRhIiwiYSI6ImNqODI4MzB0bDUyMnEyd28zZzhnbHlnNjUifQ.D9Pxal6hLEnREf4HsYrSdQ#/152.2772/-33.0881/10"
              eventName="map-information: select improve this map"
              description="Improve this map"
            />
          </NavList>
        </Card.Body>
      </Card>
    </SheetBody>
  </SheetLayout>
);

export default MapInformationPage;
